<section>
    <div class="commercial" *ngIf="isBusinessUser; else resiUser">
        <h2 class="header" [innerHtml]="pageData.subheader"></h2>
        <div *ngIf="pageData.call" class="call-us">
            <span class="call-text">{{ pageData.call.title }}</span>&ngsp;
            <span class="call-text" *ngIf="!isMobile">{{ pageData.call.title2 }} <span class="number">{{pageData.call.number}}</span></span>&ngsp;
            <a rel="noopener" class="call-text" [href]="pageData.call.link" *ngIf="isMobile">{{ pageData.call.title2 }} <span class="number">{{pageData.call.number}}</span></a>
        </div>
    </div>
    <ng-template #resiUser>
        <div class="footer">
            <span class="footer-text"> {{ pageData.chat.icon.name }} </span> 
            <xm-media-image class="footer-image" aria-hidden="true" size="height" [imageOptions]="chatIcon"></xm-media-image>
        </div>
        <p class="subheader" [innerHtml]="pageData.subheader"></p>
        <button class="title"  role="link" type="button" (click)="openChat()" [innerHtml]="pageData.chat.title"></button>
        <div *ngIf="pageData.call" class="call-us">
            <span class="call-text">{{ pageData.call.title }}</span>&ngsp;
            <span class="call-text" *ngIf="!isMobile">{{ pageData.call.title2 }} <span class="number">{{pageData.call.number}}</span></span>&ngsp;
            <a rel="noopener" class="call-text" [href]="pageData.call.link" *ngIf="isMobile">{{ pageData.call.title2 }} <span class="number">{{pageData.call.number}}</span></a>
            <button class="vht" xmAriaFocus *ngIf="cimaToken.isLoggedIn && vhtAllowed && callInstructions"  (click)="openVhtModal()">{{ callInstructions }}</button>
        </div>
    </ng-template>
</section>
